import type { GetApiPortalMeServiceRequestsParams } from '@smartsash/api-client';

/**
 * Cache keys for My requests (HS-1548).
 *
 * A leaf module with no imports of its own features, so the dashboard's access-extension write can
 * invalidate these keys (Decision 10) without the two data layers importing each other.
 */
export const serviceRequestKeys = {
  root: ['portal', 'serviceRequests'] as const,
  list: (params: GetApiPortalMeServiceRequestsParams) =>
    ['portal', 'serviceRequests', 'list', params] as const,
  detail: (requestId: string) => ['portal', 'serviceRequests', 'detail', requestId] as const,
};
